// extracted by mini-css-extract-plugin
export default {"device1":"Background_device1__+kbyG","device2":"Background_device2__Jnc34","redHatch":"Background_redHatch__Z1On8"};